import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";

import { Copyright } from "@/_components";

export const DrawerFooter = () => {
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl = countryCode === "AU" ? "au" : "com";
  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container direction="row" style={{ margin: "auto" }}>
          <Grid item>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/terms-of-use/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                paddingRight: 15,
                paddingLeft: 44,
                color: "#1c355e",
                textDecoration: "none",
              }}
            >
              {t("policies.termsofUseLabel")}
            </Link>
          </Grid>
          <Grid item>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/privacy-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c355e", textDecoration: "none" }}
            >
              {t("policies.privacyLabel")}
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row">
          <Grid item>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/cookie-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                paddingRight: 15,
                paddingLeft: 60,
                color: "#1c355e",
                textDecoration: "none",
              }}
            >
              {t("policies.cookiesLabel")}
            </Link>
          </Grid>
          <Grid item>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/quality-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c355e", textDecoration: "none" }}
            >
              {t("policies.qualityLabel")}
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Copyright />
      </Grid>
    </Grid>
  );
};
